class VideoBanner extends HTMLElement {
    constructor() {
        super();
        const videoDesktop = this.querySelector('.video--desktop');
        const videoMobile = this.querySelector('.video--mobile');

        if (window.innerWidth > 991) {
            videoDesktop.play();
            videoMobile.pause();
        } else {
            videoDesktop.pause();
            videoMobile.play();
        }
    }
}
  
customElements.define('video-banner', VideoBanner);